"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownMenu = exports.Buttons = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Buttons = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n\n    .btn {\n        display: flex;\n        flex-basis: 30px;\n        align-items: center;\n        justify-content: center;\n        border-radius: 3px;\n        margin-right: 2px;\n        height: 30px;\n        width: 30px;\n        font-size: 1.2rem;\n        backface-visibility: hidden;\n        -webkit-font-smoothing: subpixel-antialiased;\n        box-shadow: none !important;\n        padding: 5px;\n        color: ", ";\n        background-color: transparent;\n\n        &.btn-active {\n            background-color: #444444;\n        }\n\n        svg {\n            width: 100%;\n        }\n    }\n"])), function (props) {
  return props.theme.admin.editor.text;
});

exports.Buttons = Buttons;

var DropdownMenu = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 1000;\n    display: none;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #fff;\n    text-align: left;\n    list-style: none;\n    background-color: #444444;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 3px;\n    a {\n        color: #fff;\n        cursor: pointer;\n        &:hover {\n            color: #fff;\n            background-color: #666;\n        }\n    }\n"])));

exports.DropdownMenu = DropdownMenu;